import React from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(10px);
`;

const Modal = styled(motion.div)`
  background: ${props => props.themeMode === 'light' 
    ? 'linear-gradient(135deg, #ffffff 0%, #f8f5ff 100%)' 
    : 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)'};
  border-radius: 30px;
  padding: 3rem;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(124, 77, 255, 0.3);
`;

const Title = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 2rem;
  background: linear-gradient(90deg, #7c4dff 0%, #536dfe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const LanguageButtons = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const LanguageButton = styled(motion.button)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem 3rem;
  border: 2px solid rgba(124, 77, 255, 0.3);
  border-radius: 20px;
  background: ${props => props.themeMode === 'light' 
    ? 'rgba(124, 77, 255, 0.05)' 
    : 'rgba(255, 255, 255, 0.05)'};
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: #7c4dff;
    background: rgba(124, 77, 255, 0.15);
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(124, 77, 255, 0.3);
  }
`;

const FlagEmoji = styled.span`
  font-size: 3rem;
`;

const LanguageName = styled.span`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${props => props.themeMode === 'light' ? '#333' : '#fff'};
`;

const LanguageSelector = () => {
  const { showSelector, selectLanguage, setLanguage } = useLanguage();
  const { theme } = useTheme();
  const themeMode = theme.mode;

  if (!showSelector) return null;

  return (
    <AnimatePresence>
      <Overlay
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Modal
          themeMode={themeMode}
          initial={{ opacity: 0, scale: 0.8, y: 50 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 50 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        >
          <Title>Choose Your Language / Piliin ang Iyong Wika</Title>
          <LanguageButtons>
            <LanguageButton
              themeMode={themeMode}
              onClick={() => setLanguage('en')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FlagEmoji>🇺🇸</FlagEmoji>
              <LanguageName themeMode={themeMode}>English</LanguageName>
            </LanguageButton>
            <LanguageButton
              themeMode={themeMode}
              onClick={() => setLanguage('fil')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FlagEmoji>🇵🇭</FlagEmoji>
              <LanguageName themeMode={themeMode}>Filipino</LanguageName>
            </LanguageButton>
          </LanguageButtons>
        </Modal>
      </Overlay>
    </AnimatePresence>
  );
};

export default LanguageSelector;
